import { subscribe } from "@shared/utils.events"
import { removeNullField } from "tracking/utils/nullFields"
import { useSegment } from "./useSegment"

export const useVideoPlayerTracking = (): (() => void) => {
  const { track } = useSegment()

  return () => {
    subscribe("video.onplay", ({ target: video, position }) => {
      const { duration, baseURI, title } = video as unknown as HTMLVideoElement
      track({
        event: "Video Playback Started",
        properties: {
          total_length: removeNullField(duration),
          video_content_id: baseURI,
          video_content_title: title,
          video_position: position as string | undefined,
        },
      })
    })

    subscribe("video.onpause", ({ target: video, position }) => {
      const { currentTime, duration, baseURI, title } =
        video as unknown as HTMLVideoElement
      const remaining = duration - currentTime
      if (remaining >= 0.05) {
        track({
          event: "Video Playback Paused",
          properties: {
            total_length: removeNullField(duration),
            video_content_id: baseURI,
            video_content_title: title,
            video_position: position as string | undefined,
          },
        })
      }
    })

    subscribe("video.onended", ({ target: video, position }) => {
      const { duration, baseURI, title } = video as unknown as HTMLVideoElement
      track({
        event: "Video Playback Completed",
        properties: {
          total_length: removeNullField(duration),
          video_content_id: baseURI,
          video_content_title: title,
          video_position: position as string | undefined,
        },
      })
    })
  }
}
